import { SimpleTable } from '@app/components/base/SimpleTable';
import { Box } from '@mui/material';
import { fixedWidthColumnProps } from './hls-timeline-fixed-table';
import { formatBytes, formatSeconds } from './hls-timeline-stats';
import { HlsTimelineBufferRow } from './hls-timeline-stats-types';
import { HlsTimelineBufferSummaryTable } from './HlsTimelineBufferSummaryTable';

type HlsTimelineBufferRowsTableProps = {
  rows: HlsTimelineBufferRow[];
  currentTime: number | null;
  maxBufferLength: number | null;
  forwardBufferInfo: { len: number; start: number; end: number } | null;
};

/** Tabular view of media and SourceBuffer rows shown in the HLS timeline chart. */
export function HlsTimelineBufferRowsTable({
  rows,
  currentTime,
  maxBufferLength,
  forwardBufferInfo,
}: HlsTimelineBufferRowsTableProps) {
  return (
    <>
      <HlsTimelineBufferSummaryTable
        currentTime={currentTime}
        maxBufferLength={maxBufferLength}
        forwardBufferInfo={forwardBufferInfo}
      />
      <Box sx={{ mt: 1 }}>
        <SimpleTable
          fixedLayout
          columns={[
            {
              header: 'Row',
              renderCell: (row) => row.id,
              ...fixedWidthColumnProps('18%'),
            },
            {
              header: 'Type',
              renderCell: (row) => row.bufferKind,
              ...fixedWidthColumnProps('8%'),
            },
            {
              header: 'Buffered',
              renderCell: (row) => formatBytes(row.bufferedBytes),
              ...fixedWidthColumnProps('10%'),
            },
            {
              header: 'Ranges',
              renderCell: (row) => row.rangeCount,
              ...fixedWidthColumnProps('7%'),
            },
            {
              header: 'Total',
              renderCell: (row) => formatSeconds(row.totalDuration),
              ...fixedWidthColumnProps('10%'),
            },
            {
              header: 'Forward',
              renderCell: (row) => formatSeconds(row.forwardBuffer),
              ...fixedWidthColumnProps('10%'),
            },
            {
              header: 'Back',
              renderCell: (row) => formatSeconds(row.backBuffer),
              ...fixedWidthColumnProps('10%'),
            },
            {
              header: 'Start',
              renderCell: (row) => formatSeconds(row.bufferStart),
              ...fixedWidthColumnProps('12%'),
            },
            {
              header: 'End',
              renderCell: (row) => formatSeconds(row.bufferEnd),
              ...fixedWidthColumnProps('12%'),
            },
          ]}
          data={rows}
        />
      </Box>
    </>
  );
}
